<template>
  <div>
    <div v-for="(argument, i) in $t('subscriptions.' + subscription.module + '.plans.' + subscription.plan + '.arguments')" :key="i">
      <v-icon color="success" v-if="argument.type === 'good'">mdi-check</v-icon>
      <v-icon color="error" v-else>mdi-close</v-icon>
      <span v-html="description(argument)"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanArguments',
  props: ['subscription'],
  methods: {
    arguments () {
      return this.$t('subscriptions.' + this.subscription.module + '.plans.' + this.subscription.plan + '.arguments')
    },
    description (argument) {
      try {
        return eval('"' + argument.description + '"')
      } catch (e) {
        console.error('Error computing plan argument "' + argument.description + '"', e)
        return argument.description
      }
    },
    price (number) {
      if (this.subscription.yearly) return this.$helpers.present.currency(number / 12) + this.$t('prices.without-taxes') + ' / ' + this.$t('dates.months')
      else return this.$helpers.present.currency(number) + this.$t('prices.without-taxes') + ' / ' + this.$t('dates.months')
    }
  }
}
</script>

<style scoped>

</style>



